import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TickCrossBooleanDisplay from '../TickCrossBooleanDisplay.vue';
import CheckCircle from '../svg/CheckCircle.vue';
import CrossCircle from '../svg/CrossCircle.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OverallValidationBooleanDisplay',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TickCrossBooleanDisplay, null, {
    true: _withCtx(() => [
      _createVNode(CheckCircle, { class: "true" })
    ]),
    false: _withCtx(() => [
      _createVNode(CrossCircle, { class: "false" })
    ]),
    _: 1
  }))
}
}

})